"use client";
import * as S from "./styles.ts";
import { H1, TextDropdown } from "@template/components";
import { CostCard, ICostCardProps } from "./CostCard";
import { InternationalCostCard } from "./InternationalCostCard";
import UnitedKingdom from "@/lib/images/flags/UnitedKingdom.svg";
import RestOfWorld from "@/lib/images/flags/RestOfWorld.svg";
import UnitedStates from "@/lib/images/flags/UnitedStates.svg";
import useBreakpoint from "@/lib/helpers/hooks/useBreakpoint.ts";
import { useEffect, useState } from "react";

interface ICallRatesCostsSectionComponentProps {
  inverted?: boolean;
  context?: "international";
  title?: string;
}

const InternationalData: any[] = [
  {
    label: "Europe",
    prices: [
      {
        destination: "Andorra",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Andorra.png",
        priceDetails: [
          { price: "4.0", copy: "Landline" },
          { price: "20.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Austria",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Austria.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "9.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Belgium",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Belgium.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "4.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Bulgaria",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Bulgaria.png",
        priceDetails: [
          { price: "6.0", copy: "Landline" },
          { price: "25.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Croatia",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Croatia.png",
        priceDetails: [
          { price: "5.0", copy: "Landline" },
          { price: "15.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Cyprus",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Cyprus.png",
        priceDetails: [
          { price: "2.5", copy: "Landline" },
          { price: "7.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Czech Republic",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Czech-Republic.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "9.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Denmark",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Denmark.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "2.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Estonia",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Estonia.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "20.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Finland",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Finland.png",
        priceDetails: [
          { price: "5.0", copy: "Landline" },
          { price: "15.0", copy: "Mobile" },
        ],
      },
      {
        destination: "France",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/France.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "9.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Germany",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Germany.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "9.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Gibraltar",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Gibraltar.png",
        priceDetails: [
          { price: "5.0", copy: "Landline" },
          { price: "25.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Greece",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Greece.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "11.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Guadeloupe",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/France.png",
        priceDetails: [
          { price: "5.0", copy: "Landline" },
          { price: "20.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Hungary",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Hungary.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "15.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Iceland",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Iceland.png",
        priceDetails: [
          { price: "3.0", copy: "Landline" },
          { price: "15.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Ireland",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Ireland.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "9.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Italy",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Italy.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "9.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Latvia",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Latvia.png",
        priceDetails: [
          { price: "5.0", copy: "Landline" },
          { price: "15.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Lithuania",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Lithuania.png",
        priceDetails: [
          { price: "5.0", copy: "Landline" },
          { price: "15.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Luxembourg",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Luxembourg.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "15.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Malta",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Malta.png",
        priceDetails: [
          { price: "5.0", copy: "Landline" },
          { price: "10.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Martinique",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Martinique.png",
        priceDetails: [
          { price: "5.0", copy: "Landline" },
          { price: "10.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Netherlands",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Netherlands.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "9.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Norway",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Norway.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "2.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Poland",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Poland.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "9.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Portugal",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Portugal.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "9.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Romania",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Romania.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "9.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Slovakia",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Slovakia.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "9.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Slovenia",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Slovenia.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "9.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Spain",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Spain.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "9.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Sweden",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Sweden.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "2.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Switzerland",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Switzerland.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "20.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Turkey",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Turkey.png",
        priceDetails: [
          { price: "3.0", copy: "Landline" },
          { price: "11.5", copy: "Mobile" },
        ],
      },
      {
        destination: "Ukraine",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Ukraine.png",
        priceDetails: [
          { price: "15.0", copy: "Landline" },
          { price: "25.0", copy: "Mobile" },
        ],
      },

      {
        destination: "United Kingdom",
        destinationFlagUrl: UnitedKingdom,
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "9.0", copy: "Mobile" },
        ],
      },
    ],
  },
  {
    label: "Americas",
    prices: [
      {
        destination: "Argentina",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Argentina.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "14.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Brazil",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Brazil.png",
        priceDetails: [
          { price: "1.5", copy: "Landline" },
          { price: "9.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Bermuda",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Bermuda.png",
        priceDetails: [
          { price: "9.0", copy: "Landline" },
          { price: "9.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Canada",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Canada.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "2.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Chile",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Chile.png",
        priceDetails: [
          { price: "2.5", copy: "Landline" },
          { price: "14.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Colombia",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Colombia.png",
        priceDetails: [
          { price: "3.5", copy: "Landline" },
          { price: "6.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Costa Rica",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Costa-Rica.png",
        priceDetails: [
          { price: "5.0", copy: "Landline" },
          { price: "8.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Ecuador",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Ecuador.png",
        priceDetails: [
          { price: "13.0", copy: "Landline" },
          { price: "21.5", copy: "Mobile" },
        ],
      },
      {
        destination: "Guam",
        destinationFlagUrl: "https://yay.com/static/img/flags/checker/Guam.png",
        priceDetails: [
          { price: "1.5", copy: "Landline" },
          { price: "1.5", copy: "Mobile" },
        ],
      },
      {
        destination: "Jamaica",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Jamaica.png",
        priceDetails: [
          { price: "25.0", copy: "Landline" },
          { price: "25.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Mexico",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Mexico.png",
        priceDetails: [
          { price: "1.0", copy: "Landline" },
          { price: "3.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Panama",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Panama.png",
        priceDetails: [
          { price: "5.0", copy: "Landline" },
          { price: "15.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Paraguay",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Paraguay.png",
        priceDetails: [
          { price: "10.0", copy: "Landline" },
          { price: "20.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Peru",
        destinationFlagUrl: "https://yay.com/static/img/flags/checker/Peru.png",
        priceDetails: [
          { price: "1.5", copy: "Landline" },
          { price: "9.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Puerto Rico",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Puerto-Rico.png",
        priceDetails: [
          { price: "1.5", copy: "Landline" },
          { price: "1.5", copy: "Mobile" },
        ],
      },
      {
        destination: "United States",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/United-States.png",
        priceDetails: [
          { price: "1.5", copy: "Landline" },
          { price: "1.5", copy: "Mobile" },
        ],
      },
      {
        destination: "Venezuela",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Venezuela.png",
        priceDetails: [
          { price: "5.0", copy: "Landline" },
          { price: "15.0", copy: "Mobile" },
        ],
      },
    ],
  },
  {
    label: "Africa",
    prices: [
      {
        destination: "Egypt",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Egypt.png",
        priceDetails: [
          { price: "12.0", copy: "Landline" },
          { price: "12.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Ghana",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Ghana.png",
        priceDetails: [
          { price: "25.0", copy: "Landline" },
          { price: "25.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Kenya",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Kenya.png",
        priceDetails: [
          { price: "20.0", copy: "Landline" },
          { price: "25.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Morocco",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Morocco.png",
        priceDetails: [
          { price: "6.0", copy: "Landline" },
          { price: "45.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Nigeria",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Nigeria.png",
        priceDetails: [
          { price: "10.0", copy: "Landline" },
          { price: "10.0", copy: "Mobile" },
        ],
      },
      {
        destination: "South Africa",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/South-Africa.png",
        priceDetails: [
          { price: "20.0", copy: "Landline" },
          { price: "20.0", copy: "Mobile" },
        ],
      },
    ],
  },
  {
    label: "Asia",
    prices: [
      {
        destination: "Bahrain",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Bahrain.png",
        priceDetails: [
          { price: "15.0", copy: "Landline" },
          { price: "20.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Bangladesh",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Bangladesh.png",
        priceDetails: [
          { price: "3.0", copy: "Landline" },
          { price: "3.0", copy: "Mobile" },
        ],
      },
      {
        destination: "China",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/China.png",
        priceDetails: [
          { price: "4.0", copy: "Landline" },
          { price: "4.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Hong Kong",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Hong-Kong.png",
        priceDetails: [
          { price: "7.5", copy: "Landline" },
          { price: "7.5", copy: "Mobile" },
        ],
      },
      {
        destination: "India",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/India.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "2.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Indonesia",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Indonesia.png",
        priceDetails: [
          { price: "3.5", copy: "Landline" },
          { price: "5.5", copy: "Mobile" },
        ],
      },
      {
        destination: "Iran",
        destinationFlagUrl: "https://yay.com/static/img/flags/checker/Iran.png",
        priceDetails: [
          { price: "20.0", copy: "Landline" },
          { price: "20.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Japan",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Japan.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "9.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Malaysia",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Malaysia.png",
        priceDetails: [
          { price: "1.5", copy: "Landline" },
          { price: "5.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Mongolia",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Mongolia.png",
        priceDetails: [
          { price: "5.0", copy: "Landline" },
          { price: "10.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Oman",
        destinationFlagUrl: "https://yay.com/static/img/flags/checker/Oman.png",
        priceDetails: [
          { price: "17.0", copy: "Landline" },
          { price: "32.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Pakistan",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Pakistan.png",
        priceDetails: [
          { price: "6.5", copy: "Landline" },
          { price: "6.5", copy: "Mobile" },
        ],
      },
      {
        destination: "Philippines",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Philippines.png",
        priceDetails: [
          { price: "10.0", copy: "Landline" },
          { price: "12.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Singapore",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Singapore.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "2.0", copy: "Mobile" },
        ],
      },
      {
        destination: "South Korea",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/South-Korea.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "2.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Sri Lanka",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Sri-Lanka.png",
        priceDetails: [
          { price: "15.0", copy: "Landline" },
          { price: "15.0", copy: "Mobile" },
        ],
      },
      {
        destination: "Taiwan",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Taiwan.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "7.5", copy: "Mobile" },
        ],
      },
      {
        destination: "Thailand",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Thailand.png",
        priceDetails: [
          { price: "5.0", copy: "Landline" },
          { price: "5.0", copy: "Mobile" },
        ],
      },
      {
        destination: "United Arab Emirates",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/United-Arab-Emirates.png",
        priceDetails: [
          { price: "17.5", copy: "Landline" },
          { price: "17.5", copy: "Mobile" },
        ],
      },
      {
        destination: "Vietnam",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Vietnam.png",
        priceDetails: [
          { price: "7.5", copy: "Landline" },
          { price: "7.5", copy: "Mobile" },
        ],
      },
    ],
  },
  {
    label: "Oceania",
    prices: [
      {
        destination: "Australia",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/Australia.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "7.5", copy: "Mobile" },
        ],
      },
      {
        destination: "New Zealand",
        destinationFlagUrl:
          "https://yay.com/static/img/flags/checker/New-Zealand.png",
        priceDetails: [
          { price: "2.0", copy: "Landline" },
          { price: "9.0", copy: "Mobile" },
        ],
      },
    ],
  },
];

const SmsData: ICostCardProps[] = [
  {
    destination: "United Kingdom",
    destinationFlagUrl: UnitedKingdom,
    price: "5.0",
    priceCopy: "Sms",
  },
  {
    destination: "United States",
    destinationFlagUrl: UnitedStates,
    price: "5.0",
    priceCopy: "Sms",
  },
  {
    destination: "Rest of World",
    destinationFlagUrl: RestOfWorld,
    price: "12.0",
    priceCopy: "Sms",
  },
];

const LocalData: ICostCardProps[] = [
  {
    destination: "United Kingdom",
    destinationFlagUrl: UnitedKingdom,
    price: "1.0",
    priceCopy: "Landline",
  },
  {
    destination: "United Kingdom",
    destinationFlagUrl: UnitedKingdom,
    price: "7.5",
    priceCopy: "Mobile",
  },
];

const CallRatesCostsSectionComponent = ({
                                          inverted = false,
                                          context,
                                          title,
                                        }: ICallRatesCostsSectionComponentProps) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  const isSm = !useBreakpoint("md").check;
  const isMd = !useBreakpoint("lg").check;
  const numberOfColumns = isSm ? 1 : isMd ? 2 : 3;
  return (
    <S.CallRatesCostsSectionWrapper $inverted={inverted}>
      <S.CallRatesCostsContainer>
        {title && <H1 as="h2">{title}</H1>}
        {context === "international" ? (
          InternationalData.map((data, index) => (
            <TextDropdown
              title={data.label}
              key={index}
            >
              <S.IntlCostCardGrid>
                {mounted &&
                  data.prices.map((data, index) => {
                    const displayLabels = index < numberOfColumns;
                    return (
                      <InternationalCostCard
                        showLabels={displayLabels}
                        key={index}
                        {...data}
                      />
                    );
                  })}
              </S.IntlCostCardGrid>
            </TextDropdown>
          ))
        ) : (
          <>
            <TextDropdown title="Local Call Costs">
              <S.CostCardsContainer>
                {LocalData.map((data, index) => (
                  <CostCard
                    key={index}
                    {...data}
                  />
                ))}
              </S.CostCardsContainer>
            </TextDropdown>
            <TextDropdown title="SMS">
              <S.CostCardsContainer>
                {SmsData.map((data, index) => (
                  <CostCard
                    key={index}
                    {...data}
                  />
                ))}
              </S.CostCardsContainer>
            </TextDropdown>
          </>
        )}
      </S.CallRatesCostsContainer>
    </S.CallRatesCostsSectionWrapper>
  );
};

export default CallRatesCostsSectionComponent;
export const options = [
  {
    description: "",
    displayName: "CallRatesCostsSectionComponent",
    methods: [],
    props: {
      inverted: {
        required: false,
        flowType: { name: "boolean" },
        description: "",
        defaultValue: { value: "false", computed: false },
      },
      context: {
        required: false,
        flowType: { name: "literal", value: "\"international\"" },
        description: "",
      },
      title: {
        required: false,
        flowType: { name: "string" },
        description: "",
      },
    },
  },
];
